/* eslint-disable */
import masks from './masks';
import { formatDate } from './formatters';
import ddds from './ddd';

const daysInMonth = (m, y) =>
  ({
    1: (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28,
    8: 30,
    3: 30,
    5: 30,
    10: 30,
  }[m] ?? 31);

export const minLength = size => ({
  validate: value => value.length < size,
  errorMessage: `Preencha com no mínimo ${size} caracteres`,
});

export const maxLength = size => ({
  validate: value => value.length > size,
  errorMessage: `Preencha com no máximo ${size} caracteres`,
});

export const required = {
  validate: value => `${value}`.length === 0,
  errorMessage: 'Campo obrigatório',
};
export const hasSurname = {
  validate: value => !/(\w{3,})\s(\w{2,})/.test(value),
  errorMessage: 'Sobrenome obrigatório',
};
export const lessThan = (
  quantity,
  customMessage,
  callbackMask = text => text
) => ({
  validate: value => parseFloat(value) > quantity,
  errorMessage:
    customMessage ||
    `Informe valor menor ou igual a ${callbackMask(`${quantity}`)}`,
});

export const greaterThan = (
  quantity,
  customMessage,
  callbackMask = text => text
) => ({
  validate: value => parseFloat(value) < quantity,
  errorMessage:
    customMessage ||
    `Informe valor maior ou igual a ${callbackMask(`${quantity}`)}`,
});
export const validCnpj = {
  validate: strCnpj => {
    if (strCnpj.length < 14) {
      return true;
    }

    const key = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const key2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    const getDigit = calc => {
      const digitCheck = calc % 11;
      return digitCheck < 2 ? 0 : 11 - digitCheck;
    };
    const cnpjSum = (arrCnpj, key) =>
      arrCnpj
        .map((digit, i) => digit * key[i])
        .reduce((acc, digit) => acc + digit, 0);

    const sum = cnpjSum(strCnpj.substring(0, 12).split(''), key);

    const firstDigit = getDigit(sum);

    if (firstDigit !== parseInt(strCnpj.charAt(12))) {
      return true;
    }

    const lastSum = cnpjSum(strCnpj.substring(0, 13).split(''), key2);

    const lastDigit = getDigit(lastSum);

    if (lastDigit !== parseInt(strCnpj.charAt(13))) {
      return true;
    }
    return false;
  },
  errorMessage: 'cnpj inválido',
};

export const validCep = {
  validate: value => value.length !== 8,
  errorMessage: 'Informe um CEP válido',
};


export const validCpf = {
  validate: strCPF => {
    let Soma;
    let Resto;
    Soma = 0;

    if (strCPF.split('').every((curr,_,arr) => curr === arr[0])) {
      return true;
    }
    for (let i = 1; i <= 9; i++) {
      Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11){
      Resto = 0;
    }
    if (Resto !== parseInt(strCPF.substring(9, 10))) {
      return true;
    }

    Soma = 0;
    for (let i = 1; i <= 10; i++) {
      Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    }
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11){
      Resto = 0;
    }
    return Resto !== parseInt(strCPF.substring(10, 11));
  },
  errorMessage: 'CPF inválido',
};

const invalidPhoneMessage = 'Telefone inválido';
const invalidDateMessage = 'Data inválida';

export const validPhone = {
  validate: value => !/^([0])?[1-9]{2}(9)([0-9]{4})[0-9]{4}$/.test(value),
  errorMessage: invalidPhoneMessage,
};
export const validHomePhone = {
  validate: value => !/^([0])?[1-9]{2}([0-9]{4})[0-9]{4}$/.test(value),
  errorMessage: invalidPhoneMessage,
};
export const validCommercialPhone = {
  validate: value => !/^([0])?[1-9]{2}([0-9]{4})[0-9]{4}$/.test(value) && !/^([0])?[1-9]{2}(9)([0-9]{4})[0-9]{4}$/.test(value),
  errorMessage: invalidPhoneMessage,
};
export const validDDD = {
  validate: value => {
    const ddd = parseInt(value.substring(0, 2));

    return !ddds.includes(ddd);
  },
  errorMessage: 'DDD inválido',
};

export const validPhoneLength = {
  validate: minLength(11).validate,
  errorMessage: invalidPhoneMessage,
};

export const validCommercialPhoneLength = {
  validate: minLength(11).validate && minLength(10).validate,
  errorMessage: invalidPhoneMessage,
}


export const validHomePhoneLength = {
  validate: minLength(10).validate,
  errorMessage: invalidPhoneMessage,
};

export const validBirthdate = {
  validate: value =>
    !/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(
      masks.date.mask(value)
    ),

  errorMessage: invalidDateMessage,
};
export const validBirthdateDay = {
  validate: value => {
    const separated = value.split('/');
    const y = parseInt(separated[2], 10);
    const m = parseInt(separated[1], 10) - 1;
    const d = parseInt(separated[0], 10);

    return !(m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y));
  },
  errorMessage: invalidDateMessage,
};

export const validBirthdateRange = {
  validate: value => new Date() < new Date(formatDate(value)),
  errorMessage: invalidDateMessage,
};

export const validAge = (minAge,maxAge) => ({
  validate: value => {
    const currentYear = new Date().getFullYear()
    const formatedDate = `${formatDate(value)}T00:00:00`

    const receivedDate = new Date(formatedDate)
    const minDate = new Date()
    const maxDate = new Date()

    minDate.setFullYear(currentYear - minAge)
    maxDate.setFullYear((currentYear - maxAge) -1 )

    return receivedDate >= minDate || receivedDate <= maxDate

  },
  errorMessage: 'Só é permitido a venda para maiores de 16 anos e menores de 100',
})

export const validEmail = {
  validate: value => {
    return !/(^\w.*@[\w-]+\.\w)/.test(value);
  },
  errorMessage: 'E-mail inválido',
};

export const lettersOnly = {
  validate: value => {
    return !/^[a-zA-Z\s]+$/.test(value);
  },
  errorMessage: 'Caracteres especiais e/ou números não permitidos',
};

export const agency = {
  validate: value => {
    return value.length < 5;
  },
  errorMessage: 'Agência inválida',
};

export const account = {
  validate: value => {
    return value.length < 4;
  },
  errorMessage: 'Conta inválida',
};

export const isAnyInvalidField = (functions, value = '') => () => ({
  validate: () => {
    const invalid = functions
      .reverse()
      .reduce((acc, validate) => validate() || acc, false);
    return {
      invalid,
      value,
    };
  },
});

export const lessThanUnknownValue = (
  unknown,
  quantity,
  errorMessage = 'Valor inválido'
) => ({
  validate: () => unknown > quantity,
  errorMessage,
});
